<template>
  <div>
    <span v-if="pageType == 'login'" class="span" @click="showInvite">{{
      $t("common.registerAndInvitation")
    }}</span>
    <el-button
      v-if="pageType == 'notlogin'"
      type="primary"
      @click="showInvite"
      size="mini"
      style="margin-right: 10px"
      ><span>{{ $t("common.registerAndInvitation") }}</span></el-button
    >
    <el-dialog
      :title='$t("common.registerAndInvitation")'
      :visible.sync="dialogVisible"
      :width="isPc ? '30%' : '100%'"
      :before-close="handleClose"
    >
      <div class="outbox" v-if="dialogVisible">
        <div>
          <div ref="pretext" class="textbox">
            <p>
              <!-- {{$store.state.dict.lang}} -->
              <span>{{ $t("common.shareInMsg") }}</span
              ><span v-if="$store.state.dict.lang == 'zh'"
                >【{{ meetingSubject?meetingSubject:meetingSubjectEn }}】。</span
              ><span v-if="$store.state.dict.lang == 'en'"
                > {{ meetingSubjectEn?meetingSubjectEn:meetingSubject }}.</span
              >
            </p>
            <p>{{$t('common.clickUrl')}}</p>
            <p>
              <a :href="shareUrl" target="_blank">{{ shareUrl }}</a>
            </p>
          </div>
        </div>
        <div>
          <div>
            <p>
              <span
                class="iconfont icon-weixin"
                style="background: #50c358"
              ></span
              >{{$t('common.WeChat')}}
            </p>
          </div>
          <p class="qrcode-tip">{{$t('common.wechatShare')}}</p>
          <div id="qrcode"></div>
        </div>
      </div>
      <div class="btnout">
        <el-button type="primary" size="mini" @click="copyFunc"
          ><span>{{$t('common.copyShare')}}</span></el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from "@/utils/utils";
import $ from "jquery";
import QRCode from "qrcodejs2";
export default {
  props: ["pageType", "userName"],
  data() {
    return {
      shareUrl: "",
      dialogVisible: false,
      copyContent: "",

      meetingCode:'',
      manageSubject:'会议管理系统',
      manageSubjectEn:'Conference Management System',
      meetingSubject:'',
      meetingSubjectEn:'',
      isPc:true,
    };
  },
  created() {
    this.isPc = utils.isPc();
  },
  mounted() {
    if (this.$route.params.meetingCode) {
      this.meetingCode = this.$route.params.meetingCode;
      this.getMeetingDetail(this.meetingCode);
    }
    if (this.$store.state.dict.currentMeetingCode) {
      this.meetingCode = this.$store.state.dict.currentMeetingCode;
      this.getMeetingDetail(this.meetingCode);
    }

    this.shareUrl = location.protocol + "//" + location.host + "/#/index/" + this.meetingCode;
  },
  methods: {
    showInvite() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.createQRCode();
      });
    },
    // 生成二维码
    createQRCode() {
      const _this = this;
      // console.log('text',_this.shareUrl)
      var qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100,
        text: _this.shareUrl,
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    getMeetingDetail(meetingCode) {
      const data = {
        meetingCode: meetingCode,
      };
      this.$api.getMeetingDetail(data).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.meetingSubject = res.data.meetingSubject;
            this.meetingSubjectEn = res.data.meetingSubjectEn;
          }
        }
      });
    },
    handleClose(done) {
      done();
      // $("#qrcode").empty();
    },
    //复制功能
    copyFunc() {
      this.copyContent = this.$refs["pretext"].innerText;
      var input = document.createElement("textarea"); // 直接构建input
      input.value = this.copyContent; // 设置内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message({
        message: this.$t('msg.copySuccess'),
        type: "success",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "share";
</style>
